export default __webpack_public_path__ + "static/media/iphone_download.073fb4a5.png";